import anime from 'animejs/lib/anime.min.js';
import EventEmitter from "../event-emitter";

export default class SocialInput {
    constructor(props = {}) {
        this.props = props;

        this.$root = this.props.$root;
        this.$inputContentWrapper = null;
        this.$inputListContainer = null
        this.$inputContainerList = null;
        this.$triggersContainer = null;
        this.$triggerList = null;
        this.$inputList = null;

        this._eventEmitter = new EventEmitter(this.props.subscriptions || []);
        this.triggerContainerHeight = null;
        this.shownInputsCount = 0;
        this.value = null;

        this.VALUE_CHANGE_EVENT = 'valueChange';

        this.init();
    }

    init() {
        if (this.$root == null) {
            throw new Error('SocialsInput: Root element is not defined!');
        }

        this.$inputContentWrapper = this.$root.querySelector('.f-socials-input_inputs-wrapper');
        this.$inputListContainer = this.$root.querySelector('.f-socials-input_container');
        this.$inputContainerList = Array.from(this.$root.querySelectorAll('.f-socials-input-item'));
        this.$triggersContainer = this.$root.querySelector('.f-socials-input-triggers');
        this.$triggerList = Array.from(this.$root.querySelectorAll('.f-socials-input-triggers_btn'));
        this.$inputList = Array.from(this.$root.querySelectorAll('.f-socials-input-item_input'));

        this.addEventListeners();
    }

    addEventListeners() {
        /* Show Input Listeners */
        this.$triggerList.forEach(($trigger) => {
            $trigger.addEventListener('click', () => {
                const name = $trigger.dataset.name;
                const $inputContainer = this.$root.querySelector(`.f-socials-input-item[data-name="${name}"]`);
                this.triggerContainerHeight = this.$triggersContainer.offsetHeight;

                $trigger.classList.add('-hidden');
                this.$inputListContainer.append($inputContainer);
                $inputContainer.classList.add('-active');
                this.shownInputsCount++;

                if (this.shownInputsCount === this.$triggerList.length) {
                    anime({
                        targets: this.$triggersContainer,
                        height: [this.triggerContainerHeight, 0],
                        duration: 150,
                        easing: 'cubicBezier(0.32, 0.08, 0.24, 1)'
                    });
                }

                /* Animate Showing */
                this.animateHeight(null, {
                    halfPastCallback: () => {
                        anime({
                            targets: $inputContainer,
                            opacity: 1,
                            duration: 150,
                            easing: 'cubicBezier(0.32, 0.08, 0.24, 1)'
                        });
                    }
                });
            });
        });

        /* Hide Input Listeners */
        this.$inputContainerList.forEach(($inputContainer) => {
            $inputContainer.addEventListener('click', (e) => {
                const $hide = e.target.closest('.f-socials-input-item_hide');

                if ($hide) {
                    e.stopPropagation();

                    const name = $inputContainer.dataset.name;
                    const $trigger = this.$triggerList.find(($trigger) => $trigger.dataset.name === name);
                    this.removeValue(name);
                    this.shownInputsCount--;

                    /* Animate Hiding */
                    if ((this.shownInputsCount + 1) === this.$triggerList.length && this.triggerContainerHeight) {
                        anime({
                            targets: this.$triggersContainer,
                            height: this.triggerContainerHeight,
                            duration: 150,
                            easing: 'cubicBezier(0.32, 0.08, 0.24, 1)',
                            update: (anim) => {
                                if ($trigger.classList.contains('-hidden') && anim.progress >= 85) {
                                    $trigger.classList.remove('-hidden');
                                }
                            }
                        });
                    } else {
                        $trigger.classList.remove('-hidden');
                    }
                    this.animateHeight(this.$inputContentWrapper.offsetHeight - $inputContainer.offsetHeight);
                    $inputContainer.classList.remove('-active');
                    $inputContainer.style.opacity = null;
                    $hide.previousElementSibling.value = '';
                }
            });

            $inputContainer.addEventListener('input', (e) => {
                if (e.target.closest('.f-socials-input-item_input')) {
                    e.stopPropagation();

                    const name = $inputContainer.dataset.name;
                    const value = e.target.value.trim();

                    if (value.length > 255) {
                        e.target.value = value;
                    }

                    this.setValue(name, value);
                }
            });
        });
    }

    setValue(name, value) {
        if (name == null || value == null) return;

        if (this.value == null) {
            this.value = {};
        }

        this.value[name] = value;

        if (!this.value[name].length) {
            this.removeValue(name);
        } else {
            this._eventEmitter.dispatch(this.VALUE_CHANGE_EVENT, this.value);
        }
    }

    removeValue(name) {
        if (this.value == null || name == null) return;

        delete this.value[name];

        if (!Object.keys(this.value).length) {
            this.value = null;
        }

        this._eventEmitter.dispatch(this.VALUE_CHANGE_EVENT, this.value);
    }

    dropState() {
        this.value = null;
        this.triggerContainerHeight = null;
        this.shownInputsCount = 0;
        this._eventEmitter.dispatch(this.VALUE_CHANGE_EVENT, this.value);

        this.$triggerList.forEach(($trigger) => {
            $trigger.classList.remove('-hidden');
        });
        this.$inputList.forEach(($input) => {
            $input.value = '';
            $input.parentElement.classList.remove('-active');
        });

        this.setInitialHeight();
    }

    setInitialHeight() {
        this.$inputContentWrapper.removeAttribute('style');
        this.$triggersContainer.removeAttribute('style');
    }

    animateHeight(newHeight, { halfPastCallback, complete } = {}) {
        const oldHeight = this.$inputContentWrapper.offsetHeight;
        newHeight = newHeight || this.$inputListContainer.offsetHeight;

        if (oldHeight == null || newHeight == null) return;

        if (newHeight < 45) newHeight = 0;

        let halfPast = false;

        anime({
            targets: this.$inputContentWrapper,
            height: newHeight,
            duration: 150,
            easing: 'cubicBezier(0.32, 0.08, 0.24, 1)',
            update: (anim) => {
                if (anim.progress >= 50 && !halfPast && halfPastCallback != null) {
                    halfPastCallback();
                    halfPast = true;
                }
            },
            complete: (anim) => {
                if (anim.completed && complete) {
                    complete();
                }
            }
        });
    }
}